import React from 'react';
import { Button, ButtonWrap } from './style.js';
import { useSelector } from 'react-redux';

const CustomToggleButton = ({ setActive, isSubmitDisabled }) => {
  const { licenseDetails } = useSelector((state) => state.licenseSlice);
  const handleClick = () => {
    setActive(!licenseDetails?.isActived);
  };

  return (
    <ButtonWrap aria-disabled={isSubmitDisabled} className='af-custom-button-toggle-wrap'>
      <Button
        className='af-custom-button-toggle'
        type='primary'
        htmlType='submit'
        active={licenseDetails?.isActived}
        onClick={handleClick}
      >
        {licenseDetails?.isActived ? 'Deactivate' : 'Activate'}
      </Button>
    </ButtonWrap>
  );
};

export default CustomToggleButton;
